import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * Request builders for auth/session endpoints.
 */

/**
 * GET /saml/token_exchange — exchange the current (about-to-expire) session
 * token for a fresh one during silent renewal. Returns `{ access_token }`,
 * which the SAML authenticator consumes. The WarpDrive TIO auth handler sends
 * the current token, so this replaces the hand-rolled
 * `this.api.call('/saml/token_exchange')` in `-private/session.ts`.
 */
export function samlTokenExchangeRequest(): RequestInfo {
  const opts: QueryUrlOptions = {
    identifier: { type: 'saml' },
    op: 'query',
    resourcePath: 'saml/token_exchange',
  };
  return {
    url: buildBaseURL(opts),
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}
